require "../../../../products/frontend/helpers/productset_status_helper"
require "../../presenters/product_set_validation_presenter"

class Extranet.Views.StatusChangeValidationMessagesView extends Backbone.View

  statusHelper = Extranet.Helpers.ProductSetStatusHelper

  templateName: 'inventory_templates_monthview_status_change_validation_messages'
  violationMessages: undefined

  events:
    'click #show-violation-details': 'showViolationDetails'
    'click #hide-violation-details': 'hideViolationDetails'
    'click button.approve': 'approveProductSet'
    'click button.reject': 'rejectProductSet'
    'click button.submit': 'submitProductSet'
    'click button.submit-with-empty-lar': 'submitWithEmptyLar'
    'click button.cancel-violation-submit': 'cancelSubmission'
    'click .modal button.cancel': 'closeConfirmationPopup'
    'click .single-violation-summary-header-hide': 'toggleViolationSingleSummary'
    'click .single-violation-summary-header-show': 'toggleViolationSingleSummary'

  initialize: (options)->
    @eventManager = options.eventManager
    @autoTemplate = Extranet.Common.Utilities.AutoTemplate
    @hotelUuid = options.hotelUuid
    @productSetModel = options.productSetModel
    @presenter = Extranet.Presenters.ProductSetValidationPresenter
    @failedValidationPresenter = Extranet.Presenters.FailedValidationDatesPresenter
    @alertMessage = Extranet.Helper.AlertView.getAlertView()
    @listenTo @eventManager, 'fetchInventory', @updateHotelInfo
    @listenTo @eventManager, 'statusChangeFailure', @renderStatusChangeFailure
    @listenTo @eventManager, 'statusChangeGenericError', @renderGenericError

  updateHotelInfo: ({hotelInfo})->
    @hotelInfo = hotelInfo

  render: ()->
    actionButtonPermissions = @getActionButtonPermissions()
    @$el.html @autoTemplate.render @templateName, {@violationMessages, actionButtonPermissions}
    if actionButtonPermissions?.showActionButtons
      @eventManager.triggerEvent 'hideProductSetStatusChangeButtons'
    @show()
    this

  renderGenericError: ({error, jqxhr})->
    requestId = jqxhr?.getResponseHeader('x-request-id')
    @alertMessage.renderError(@_formatApprovalError(error), requestId)

  renderStatusChangeFailure: ({errors})->
    return @alertMessage.renderDefaultError() unless errors?.length

    # Collecting all the failed validations from each error
    @failedValidations = []
    for error in errors
      if error?.failedValidations
        for failedValidation in error.failedValidations
          @failedValidations.push(failedValidation)

    @violationMessages = @presenter.getViolationMessages(@failedValidations, @hotelInfo)
    @render()
    @showViolationDetails() if @violationMessages
    @failedValidationPresenter.format({errors})

  getAccessPermissions: () ->
    accessPermissionSubKey = @productSetModel?.get('status') or 'lastMinute'
    viewPermissions = Extranet.RolePermissions.inventory?.templates_monthview_buttons
    accessPermissions = viewPermissions?[accessPermissionSubKey]
    accessPermissions

  getActionButtonPermissions:()->
    accessPermissions = @getAccessPermissions()
    return unless accessPermissions

    showApproveButton = accessPermissions.approve?.view
    showRejectButton = accessPermissions.reject?.view
    showSubmitButton = accessPermissions.submit?.view
    showSubmitWithEmptyLarButton = @_shouldShowSubmitWithEmptyLarButton()

    showActionButtons = showApproveButton or showRejectButton or showSubmitButton or showSubmitWithEmptyLarButton

    {showActionButtons, showApproveButton, showRejectButton, showSubmitButton, showSubmitWithEmptyLarButton}

  _shouldShowSubmitWithEmptyLarButton: ()->
    accessPermissions = @getAccessPermissions()

    # Button should not be displayed when the user does not have permission
    return false unless accessPermissions?.submit_with_empty_lar?.view

    # Button should not be displayed if any non QL2 rates validation error found
    for failedValidation in @failedValidations
      return false unless failedValidation.restrictionType is "ql2Rates"

    return true

  showViolationDetails: ()->
    if @violationMessages
      $("#show-violation-details").addClass('hide')
      $("#hide-violation-details").removeClass('hide')
      @$(".violation-details").slideDown(200)
    else
      @fetchViolationDetails()

  hideViolationDetails: ()->
    $("#show-violation-details").removeClass('hide')
    $("#hide-violation-details").addClass('hide')
    @$(".violation-details").slideUp(200)

  fetchViolationDetails: ()->
    queryString = "restriction_validation=" + statusHelper.states.VIOLATIONS_ONLY.validations.join(",")

    statusChangeUrl =
      ExtranetUrlBuilder.getPsStatusChangeApiUrl
        hotelUuid: @hotelUuid
        productSetUuid: @productSetModel.get('uuid')
        qs: queryString

    jqxhr = $.ajax
      type: "PUT"
      url: statusChangeUrl
      dataType:"json"
      contentType: "application/json; charset=utf-8"
      data: {}
      headers:
        'x-csrf-token': $('#csrf_token').val()
      success: (data)=>
        @violationMessages = @presenter.getViolationMessages(data.failedValidations, @hotelInfo)
        @render()
        @showViolationDetails() if @violationMessages

      error: (jqxhr, status, errorThrown)=>
        requestId = jqxhr?.getResponseHeader('x-request-id')
        @alertMessage.renderDefaultError(requestId)

  approveProductSet: ()->
    @closeConfirmationPopup()
    @$('.rv-approval-error').addClass('hide')
    options =
      newState: statusHelper.states.APPROVE_WITH_VIOLATIONS
      hotelUuid: @hotelUuid
      productSetModel: @productSetModel
      _csrf: $("#csrf_token").val()

    ajaxCall = statusHelper.changeStateTo(options)
    ajaxCall.done( (data, textStatus, jqxhr)=>
      message = I18n.translate('js.modules.common.alerts.success.approved_with_violations')
      requestId = jqxhr?.getResponseHeader('x-request-id')
      @alertMessage.renderSuccess(message, requestId)
    ).fail( (jqxhr)=>
      requestId = jqxhr?.getResponseHeader('x-request-id')
      errorMsg = jqxhr?.responseJSON?.error or jqxhr?.responseJSON?.errorMessage
      if errorMsg
        @$('.rv-approval-error').html(@_formatApprovalError(errorMsg)).removeClass('hide')
      else
        @alertMessage.renderDefaultError(requestId)
    )

  rejectProductSet: ()->
    @closeConfirmationPopup()
    options =
      newState: statusHelper.states.REJECT
      hotelUuid: @hotelUuid
      productSetModel: @productSetModel
      _csrf: $("#csrf_token").val()

    ajaxCall = statusHelper.changeStateTo(options)
    ajaxCall.done( (data, textStatus, jqxhr)=>
      newState = "<span class='#{options.newState.name} product-set-status'>#{options.newState.name}</span>"
      message = I18n.translate('js.modules.common.alerts.success.moved_to_rejected', {newState})
      requestId = jqxhr?.getResponseHeader('x-request-id')
      @alertMessage.renderAlert(message, requestId)
    ).fail( (jqxhr)=>
      requestId = jqxhr?.getResponseHeader('x-request-id')
      @alertMessage.renderDefaultError(requestId)
    )

  submitProductSet: ()->
    @closeConfirmationPopup()
    options =
      newState: statusHelper.states.REVIEW_VIOLATIONS
      hotelUuid: @hotelUuid
      productSetModel: @productSetModel
      _csrf: $("#csrf_token").val()

    ajaxCall = statusHelper.changeStateTo(options)
    ajaxCall.done( (data, textStatus, jqxhr)=>
      newState = "<span class='#{options.newState.name} product-set-status'>#{options.newState.name}</span>"
      message = I18n.translate('js.modules.common.alerts.success.submitted_with_violations', {newState})
      requestId = jqxhr?.getResponseHeader('x-request-id')
      @alertMessage.renderSuccess(message, requestId)
    ).fail( (jqxhr)=>
      requestId = jqxhr?.getResponseHeader('x-request-id')
      @alertMessage.renderDefaultError(requestId)
    )

  submitWithEmptyLar: ()->
    @closeConfirmationPopup()
    options =
      newState: statusHelper.states.READY_WITH_EMPTY_LARS
      hotelUuid: @hotelUuid
      productSetModel: @productSetModel
      _csrf: $("#csrf_token").val()

    ajaxCall = statusHelper.changeStateTo(options)
    ajaxCall.done( (data, textStatus, jqxhr)=>
      newState = "<span class='#{options.newState.name} product-set-status'>#{options.newState.name}</span>"
      message = I18n.translate('js.modules.common.alerts.success.submitted_with_empty_lars', {newState})
      requestId = jqxhr?.getResponseHeader('x-request-id')
      @alertMessage.renderSuccess(message, requestId)
    ).fail( (jqxhr)=>
      requestId = jqxhr?.getResponseHeader('x-request-id')
      @alertMessage.renderDefaultError(requestId)
    )

  _formatApprovalError: (errorMsg)->
    # Escape HTML to prevent XSS
    escaped = $('<span>').text(errorMsg).html()

    # Split by newlines (backend sends \n-separated violations)
    lines = escaped.split('\n').map((l) -> l.trim()).filter((l) -> l.length > 0)

    if lines.length <= 1
      # Fallback: try semicolon-separated format
      lines = escaped.split(';').map((l) -> l.trim()).filter((l) -> l.length > 0)
      if lines.length <= 1
        return escaped

    header = lines[0]
    violations = lines.slice(1)

    # Group violations by rate plan name
    # Pattern: "Rate Plan **Name** on **YYYY-MM-DD**: value" or "Rate Plan Name on YYYY-MM-DD: value"
    grouped = {}
    ungrouped = []
    for violation in violations
      # Strip markdown bold markers for matching, then re-add as HTML bold
      clean = violation.replace(/\*\*/g, '')
      match = clean.match(/^(.+?)\s+on\s+(\d{4}-\d{2}-\d{2}):\s*(.+)$/)
      if match
        ratePlanName = match[1]
        grouped[ratePlanName] ?= []
        grouped[ratePlanName].push({date: match[2], value: match[3]})
      else
        ungrouped.push(clean)

    # Convert markdown bold in header to HTML bold
    formattedHeader = header.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')

    html = "<div style='margin-bottom: 8px;'>#{formattedHeader}</div>"
    html += "<div style='max-height: 300px; overflow-y: auto;'>"
    for ratePlanName, entries of grouped
      html += "<div style='margin-bottom: 6px;'>"
      html += "<b>#{ratePlanName}</b>"
      dateValues = entries.map((e) -> "<b>#{e.date}</b>: #{e.value}").join('; ')
      html += "<div style='margin-left: 12px;'>#{dateValues}</div>"
      html += "</div>"
    for item in ungrouped
      html += "<div>#{item}</div>"
    html += "</div>"
    html

  cancelSubmission: ()->
    @hide()
    @eventManager.triggerEvent 'showProductSetStatusChangeButtons'

  closeConfirmationPopup: ()->
    @$el.find('.modal .close-modal').click()

  show: ()->
    @$el.removeClass('hide')

  hide: ()->
    @$el.addClass('hide')

  toggleViolationSingleSummary: (e) ->
    currentToggleLinkParent = $(e.currentTarget).parent('.single-violation-summary')
    currentToggleLinkParent.find(".single-violation-summary-header-show").toggleClass("hide")
    currentToggleLinkParent.find(".single-violation-summary-header-hide").toggleClass("hide")
    currentToggleLinkParent.find(".single-violation-summary-list").slideToggle()
